import type { ContenidoAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de «Esperan mi respuesta» (menciones). Antes, el «?» con globito y
 * los tooltips de Atender / Resuelta / Descartar.
 */
export function ayudaMenciones(): ContenidoAyuda {
  return {
    manual: "notificaciones",
    intro: (
      <p>
        Los casos donde un compañero te mencionó en la bitácora (escribiendo <b>@TuNombre</b>) y
        todavía falta tu respuesta. Los casos cerrados no salen aquí.
      </p>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "Atender → (o tocar la mención)",
            text: "Te lleva al caso y deja la mención leída: se pone gris y deja de contar en el número de la barra, pero no se borra de la lista.",
          },
          {
            label: "Resuelta",
            text: "La das por contestada y desaparece de la lista.",
          },
          {
            label: "Descartar",
            text: "La quita sin contestar, para una mención hecha por error. Solo sale si tú escribiste esa mención o si eres admin.",
          },
          { label: "↻ Refrescar", text: "Vuelve a cargar la lista." },
        ],
      },
      {
        titulo: "Qué significa cada indicador",
        items: [
          {
            label: (
              <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded border border-accent-500/30 bg-accent-500/10 text-accent-300">
                te mencionó
              </span>
            ),
            text: "Todavía no la abres.",
          },
          { label: "Leída (renglón en gris)", text: "Ya la abriste, pero sigue esperando tu respuesta." },
          { label: "N sin leer", text: "Cuántas no has abierto. Es el mismo número de «Esperan» en la barra." },
        ],
      },
      {
        titulo: "Cuándo se quita sola",
        cuerpo: (
          <>
            <p>
              En cuanto escribes en ese caso — una nota, un correo o una respuesta al proveedor —
              tus menciones de ahí se dan por contestadas solas.
            </p>
            <p>
              Si no la contestas, te la vuelve a recordar: a las 4 horas, al día y a los dos días.
              En el último recordatorio también les avisa a quien te mencionó y a los admins.
            </p>
          </>
        ),
      },
    ],
  };
}
